export default __webpack_public_path__ + "static/media/mail.52b1590f.png";